import { Dialog, DialogContent, useTheme } from "@mui/material";
import { ModalSheet } from "./modal-sheet.js";
import { useMediaQuery } from "../utilities/index.js";
import React from "react";
export const Modal = ({ dialogProps = {}, ...props }) => {
    const theme = useTheme();
    const useDialog = useMediaQuery(theme.breakpoints.up("sm"));
    return useDialog ? (React.createElement(Dialog, { "data-testid": "modal-dialog-container", open: props.open, onClose: props.onClose, PaperProps: { sx: { borderRadius: "16px" } }, ...dialogProps },
        React.createElement(DialogContent, { "data-testid": "modal-dialog-content", sx: { px: 6, py: 6 } }, props.children))) : (React.createElement(ModalSheet, { ...props }));
};
//# sourceMappingURL=modal.js.map